import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./style.css";
export const CameraParking = ({ sensors }) => {
    //const width = widthVideo * .35
    const width = 300;
    const height = width * 0.4;
    const getLineColor = (value, warningRange, danger) => {
        if (value <= danger)
            return "#F44336";
        if (value >= warningRange[0] && value <= warningRange[1])
            return "#FFC107";
        return "#4CAF50";
    };
    const renderHorizontalLines = (sensor, isFront) => {
        if (!sensor)
            return null;
        const lineLengths = [0.8, 0.5, 0.3];
        const lineOffsetsPct = [0.15, 0.25, 0.35];
        const thresholds = [
            { warning: [80, 99], danger: 79 },
            { warning: [60, 80], danger: 59 },
            { warning: [40, 60], danger: 39 },
        ];
        return lineLengths.map((length, i) => {
            const color = getLineColor(sensor, thresholds[i].warning, thresholds[i].danger);
            const y = isFront
                ? height * lineOffsetsPct[i]
                : height - height * lineOffsetsPct[i];
            const lineWidth = width * length;
            const x1 = width / 2 - lineWidth / 2;
            const x2 = width / 2 + lineWidth / 2;
            return (_jsx("line", { x1: x1, y1: y, x2: x2, y2: y, stroke: color, strokeWidth: 3, strokeOpacity: 1 }, i));
        });
    };
    const renderVerticalLines = (sensor, isLeft) => {
        if (!sensor)
            return null;
        const lineLengths = [0.9, 0.5, 0.3];
        const lineOffsetsPct = [0.08, 0.13, 0.18];
        const thresholds = [
            { warning: [80, 99], danger: 79 },
            { warning: [60, 80], danger: 59 },
            { warning: [40, 60], danger: 39 },
        ];
        return lineLengths.map((length, i) => {
            const color = getLineColor(sensor, thresholds[i].warning, thresholds[i].danger);
            const x = isLeft
                ? width * lineOffsetsPct[i]
                : width - width * lineOffsetsPct[i];
            const y1 = height * 0.1 + (1 - length) * height * 0.4;
            const y2 = height * 0.9 - (1 - length) * height * 0.4;
            return (_jsx("line", { x1: x, y1: y1, x2: x, y2: y2, stroke: color, strokeWidth: 3, strokeOpacity: 1 }, i));
        });
    };
    const renderValue = (side, sensor) => {
        if (!sensor)
            return null;
        let x = 0, y = 0;
        let textAnchor = "start";
        let transform = "";
        switch (side) {
            case "front":
                x = width / 2;
                y = 10;
                textAnchor = "middle";
                break;
            case "rear":
                x = width / 2;
                y = height - 5;
                textAnchor = "middle";
                break;
            case "left":
                x = 0;
                y = height / 2;
                textAnchor = "start";
                transform = `rotate(-90, ${x + 15}, ${y})`;
                break;
            case "right":
                x = width;
                y = height / 2;
                textAnchor = "end";
                transform = `rotate(90, ${x - 15}, ${y})`;
                break;
        }
        let color = "#4CAF50";
        if (sensor <= 39)
            color = "#F44336";
        else if (sensor <= 99)
            color = "#FFC107";
        const className = sensor <= 39 ? "blink" : "";
        return (_jsxs("text", { x: x, y: y, fill: color, fontSize: 14, fontWeight: "700", textAnchor: textAnchor, alignmentBaseline: "middle", className: className, transform: transform, children: [sensor, " \u0441\u043C"] }, side));
    };
    return (_jsx("div", { className: "camera-parking-overlay", style: { width, height }, children: _jsxs("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, children: [renderHorizontalLines(sensors.front, true), renderHorizontalLines(sensors.rear, false), renderVerticalLines(sensors.left, true), renderVerticalLines(sensors.right, false), renderValue("front", sensors.front), renderValue("rear", sensors.rear), renderValue("left", sensors.left), renderValue("right", sensors.right)] }) }));
};
